import Select from "react-select";

function FiltersLabelKeywords({
  availableLabels,
  selectedLabels,
  setSelectedLabels,
  availableKeywords,
  selectedKeywords,
  setSelectedKeywords,
  keywordsMode,
  setKeywordsMode,
}) {
  return (
    <>
      <label>Filter by Labels</label>
      <Select
        isMulti
        options={availableLabels}
        value={selectedLabels}
        onChange={setSelectedLabels}
        className="mb-3"
      />

      <div className="row">
        <div className="col-auto">
          <Select
            options={[
              { label: "and", value: "and" },
              { label: "or", value: "or" },
            ]}
            value={keywordsMode}
            onChange={setKeywordsMode}
          />
        </div>
        <div className="col">
          <Select
            isMulti
            options={availableKeywords}
            value={selectedKeywords}
            onChange={setSelectedKeywords}
            className="mb-3"
          />
        </div>
      </div>
    </>
  );
}

export default FiltersLabelKeywords;
